// Copyright 2022 Sorama B.V.

import { BindingEngine, bindable, inject, transient } from "aurelia-framework";
import { FrontEnd } from "datatypes/SoramaLocalApi";
import {
    IWorkflowModuleInstance,
    IWorkflowModuleLifetime,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModule";
import { WorkflowPropertyBindingMode } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyMetadata";
import { workflowProperty } from "libraries/WorkflowFramework/WorkflowProperties/WorkflowPropertyAttribute";
import { ICamApi } from "services/Hardware/CamHTTP/ICamApi";
import { IHardwareService } from "services/Hardware/IHardwareService";

enum ResetState {
    Init = "init",
    Resetting = "resetting",
    Succeeded = "succeeded",
    Failed = "failed",
}

@inject(BindingEngine, "CamService", ICamApi)
@transient()
export class DeviceRecoveryModule implements IWorkflowModuleLifetime {
    private moduleInstance: IWorkflowModuleInstance;

    @bindable
    @workflowProperty({ bindingMode: WorkflowPropertyBindingMode.oneWay })
    public frontEndId: string;

    private loadingFrontEnd = true;
    private frontEnd: FrontEnd;

    private installedVersion: string;

    private resetState = ResetState.Init;

    constructor(
        private readonly bindingEngine: BindingEngine,
        private readonly camService: IHardwareService<FrontEnd>,
        private readonly camApi: ICamApi
    ) {}

    public async activateModule(moduleInstance: IWorkflowModuleInstance) {
        this.moduleInstance = moduleInstance;
        await this.camService.refresh();
        this.frontEnd = await this.camService.getHardwareById(this.frontEndId);
        this.loadingFrontEnd = false;
        this.onDeviceStatusChanged();
    }

    public deactivateModule(): void {}

    private onDeviceStatusChanged() {
        this.installedVersion = this.frontEnd.frontEndConnectors[0].version;
    }

    private factoryReset() {
        this.resetState = ResetState.Resetting;
        this.camApi
            .performFactoryReset()
            .then(() => {
                this.resetState = ResetState.Succeeded;
            })
            .catch(() => {
                this.resetState = ResetState.Failed;
            });
    }
}
